import React, { useCallback } from 'react';
import { Select } from '@atlas/ui';
import Field from 'common/Form/Field';

const optionRenderer = option => option.label;

const SelectorField = props => {
  const { field, onSetSelectableFieldIndex, fieldComponents } = props;

  const { activeSelectableFieldIndex, selectableFields, label, value } = field;

  const changeFieldHandler = useCallback(
    optionIndex => onSetSelectableFieldIndex(optionIndex),
    [onSetSelectableFieldIndex],
  );

  const options = React.useMemo(
    () =>
      selectableFields.map((field, index) => ({
        text: field.label,
        value: index,
      })),
    [selectableFields],
  );

  const selectedField = selectableFields[activeSelectableFieldIndex];
  const Component = fieldComponents[selectedField.component];

  const selectorFieldOptions = React.useMemo(
    () => ({
      ...selectedField,
      value,
    }),
    [selectedField, value],
  );

  return (
    <>
      <Field options={field}>
        <Select
          className="selector-field-select"
          optionRenderer={optionRenderer}
          options={options}
          label={label}
          value={activeSelectableFieldIndex}
          onChange={changeFieldHandler}
        />
      </Field>

      <Component {...props} field={selectorFieldOptions} />
    </>
  );
};

export default SelectorField;
